import { Absolute, Spinner } from '@revolut-internal/ui-kit'
import styled from 'styled-components'

const AbsoluteStyled = styled(Absolute)`
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
`

export const Loader = () => (
  <AbsoluteStyled>
    <Spinner color="blue" size={44} aria-label="Loading" />
  </AbsoluteStyled>
)
